// extracted by mini-css-extract-plugin
module.exports = {"form":"PasswordReset_form__2vY1I","formTitle":"PasswordReset_formTitle__15bpH","recaptcha":"PasswordReset_recaptcha__2uTXO","underformLink":"PasswordReset_underformLink__23n_H"};